<div class="appeal-hiding-text">
	<div class="appeal-hiding-text__row">
		<div class="appeal-hiding-text__title">
			{{ title }}
		</div>
		<div
			class="appeal-hiding-text__text"
			[ngClass]="{ 'appeal-hiding-text__text--hidden': isEllipsisText }"
		>
			<span #hiddenText>
				{{ text }}
			</span>
		</div>
	</div>
	@if (isVisibilityHiddenBtn) {
		<div class="appeal-hiding-text__toggle-btn-wrapper">
			<button
				class="button-text appeal-hiding-text__toggle-btn"
				type="button"
				(click)="toggleText()"
			>
				{{ buttonText }}
			</button>
		</div>
	}
</div>
